import React from 'react'
import MobileHeader from "../MobileComponents/MobileHeader";
import MobileBottomNav from "../MobileComponents/MobileBottomNav";
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AvatarPic from "../../assets/images/avtarPic.png";
// import Fab from '@mui/material/Fab';
// import AddIcon from '@mui/icons-material/Add';
// import Modal from '@mui/material/Modal';
// import CloseIcon from '@mui/icons-material/Close';
// import CreateIcon from "@mui/icons-material/Create";
// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function MobileVisitor() {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
  <div className='MainView'> 
    <MobileHeader/>
      <div className='tabView'>
      <div className='nameBtnTileView'>
        <div className="famDetailsListTo">
        <p className='visitorTxt'>Visitor List</p>
        <button className='preApprovalBtn' onClick={()=>navigate('/MobileAddPreapproval')}>Add Preapproval</button>
        </div>
      </div>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" style={{width:"100%"}}>
          <Tab label="Pending" {...a11yProps(0)} style={{width:'20%'}}/>
          <Tab label="Preapproved" {...a11yProps(1)} style={{width:'30%'}} />
          <Tab label="Rejected" {...a11yProps(2)} style={{width:'20%'}} />
          <Tab label="All Visitors" {...a11yProps(3)} style={{width:'30%'}} />
        </Tabs>
          </Box>
          
      <CustomTabPanel value={value} index={0}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <button className='visitorBtnTagTxt'>Delivery Person</button>
          </div>
        </div>
        <div className='margineTop10'>
          <p className='visitorTimedateTxt'>Arrive Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        <div className="famDetailsListTo margineTop10">
          <div className='tagInvoiceView paidTagView visitorBtnTagView'>
            <p className='tagInvoiceTxt paidColor'>Approve</p>
          </div>
          <div className='tagInvoiceView visitorBtnTagView'>
            <p className='tagInvoiceTxt'>Reject</p>
          </div>
          <div className='tagInvoiceView atGateTagView visitorBtnTagView'>
            <p className='tagInvoiceTxt atGateColor'>Leave at Gate</p>
          </div>
        </div>
        </div>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <button className='visitorBtnTagTxt'>Guest</button>
          </div>
        </div>
        <div className='margineTop10'>
          <p className='visitorTimedateTxt'>Arrive Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        <div className="famDetailsListTo margineTop10">
          <div className='tagInvoiceView paidTagView visitorBtnTagView'>
            <p className='tagInvoiceTxt paidColor'>Approve</p>
          </div>
          <div className='tagInvoiceView visitorBtnTagView'>
            <p className='tagInvoiceTxt'>Reject</p>
          </div>
        </div>
        </div>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <button className='visitorBtnTagTxt'>Visitor</button>
          </div>
        </div>
        <div className='margineTop10'>
          <p className='visitorTimedateTxt'>Arrive Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        <div className="famDetailsListTo margineTop10">
          <div className='tagInvoiceView paidTagView visitorBtnTagView'>
            <p className='tagInvoiceTxt paidColor'>Approve</p>
          </div>
          <div className='tagInvoiceView visitorBtnTagView'>
            <p className='tagInvoiceTxt'>Reject</p>
          </div>
        </div>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div style={{display:'flex', justifyContent:'flex-end'}}>
        <div className='tagInvoiceView paidTagView'>
          <p className='messageVisitorTxt'>Guest Pass <BookOnlineIcon sx={{fontSize:20, color:'#00a329'}} /> </p>
        </div>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
            <button className='visitorBtnTagTxt'>Guest</button>
          </div>
        </div>
        <div className='famDetailsListTo margineTop10'>
          <div>
            <p className='messageVisitorTxt'>Preapproval Code</p>
            <p className='messageVisitorDscrptTxt'>1234</p>
          </div>
          <div>
            <p className='messageVisitorTxt'>Approved for</p>
            <p className='messageVisitorDscrptTxt'>05:00 hrs</p>
          </div>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div>
            <p className='visitorTimedateTxt'>Proposed In Time</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
          <div>
            <p className='visitorTimedateTxt'>Proposed Out Time</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        </div>
        
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
            <button className='visitorBtnTagTxt'>Visitor</button>
          </div>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div>
            <p className='visitorTimedateTxt'>Arrive Time & Date</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
          <div>
            <p className='visitorTimedateTxt'>Purpose</p>
            <p className='pollTimeTxt'>Visitor</p>
          </div>
        </div>
        <div className='margineTop10'>
            <p className='messageVisitorTxt'>Message</p>
            <p className='messageVisitorDscrptTxt'>Description Text Description Text Description Text</p>
        </div>
        </div>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
            <button className='visitorBtnTagTxt'>Guest</button>
          </div>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div>
            <p className='visitorTimedateTxt'>Arrive Time & Date</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
          <div>
            <p className='visitorTimedateTxt'>Purpose</p>
            <p className='pollTimeTxt'>Guest</p>
          </div>
        </div>
        <div className='margineTop10'>
            <p className='messageVisitorTxt'>Message</p>
            <p className='messageVisitorDscrptTxt'>Description Text Description Text Description Text</p>
        </div>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div style={{display:'flex', justifyContent:'flex-end'}}>
        <button className='visitorBtnTagTxt'>Guest</button>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div className="margineTop10" style={{width:'50%'}}>
            <div className="alignfamDetailsListToPro" onClick={()=>navigate('/MobileVisitorDetails')}>
              <div className="ImageViewRound">
                <img src={AvatarPic} alt="altimg"/>
              </div>
              <div className="detailsDiMob">
                <h1>User Name</h1>
                <div className="mobWithIco">
                  <LocalPhoneIcon />
                  <p>9881789836</p>
                </div>
              </div>
            </div>
            <div className="preApprovalCodeView margineTop10">
              <p className='messageVisitorTxt'>Approved for</p>
              <p className='messageVisitorDscrptTxt paidColor'>05:00 hrs</p>
            </div>
          </div>
          <div style={{ width: 80, height: 80 }}>
            <CircularProgressbar value={66} text='66%' styles={buildStyles({
            // Rotation of path and trail, in number of turns (0-1)
            rotation: 0.25,

            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: 'butt',

            // Text size
            textSize: '20px',

            // How long animation takes to go from one percentage to another, in seconds
            pathTransitionDuration: 0.5,

            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: `rgba(0, 61, 255, ${66 / 100})`,
            textColor: '#0047cb',
            trailColor: '#d6d6d6',
            backgroundColor: '#3e98c7',
          })}/>
          </div>
        </div>
        <div className="famDetailsListTo margineTop10">
          <div>
            <p className='visitorTimedateTxt'>Proposed In Time</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
          <div>
            <p className='visitorTimedateTxt'>Proposed Out Time</p>
            <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        </div>
          <div className='tagInvoiceView paidTagView voteDetailsView margineTop10'>
            <p className='tagInvoiceTxt paidColor'>Extend Stay</p>
          </div>
        </div>
        </div>
      </CustomTabPanel>
        </Box>
      </div>
    <MobileBottomNav/>
  </div>
  )
}

export default MobileVisitor